import { useNavigate } from 'react-router-dom';
import * as S from './primary-button.styles'
import type { PrimaryButtonProps } from './types'

export const PrimaryButton = ({ label, icon, onClick, url }: PrimaryButtonProps) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (url) navigate(url);
        else if (onClick) onClick?.();
    };

    return (
        <S.Button onClick={handleClick} aria-label={`Botão de ${label}`}>
            <S.Icon icon={icon} />
            {label}
        </S.Button>
    )
}